import { createFeature, createReducer, on } from '@ngrx/store';
import { FidPickerItem } from '../models/fid-picker.interface';
import { loadFidPicker, loadFidPickerSuccess, loadFidPickerFailure } from './fid-picker.actions';

// Enhanced state interface with loading and error
export interface FidPickerState {
  items: FidPickerItem[];
  loading: boolean;
  error: string | null;
}

// Initial state
export const initialState: FidPickerState = {
  items: [],
  loading: false,
  error: null
};

// Feature with automatic selector generation
export const fidPickerFeature = createFeature({
  name: 'fidPicker',
  reducer: createReducer(
    initialState,
    
    // Load FID Picker (start loading)
    on(loadFidPicker, (state) => ({
      ...state,
      loading: true,
      error: null
    })),
    
    // Load FID Picker Success (effect dispatches this)
    on(loadFidPickerSuccess, (state, { items }) => ({
      ...state,
      items: items,
      loading: false,
      error: null
    })),
    
    // Load FID Picker Failure (effect dispatches this)
    on(loadFidPickerFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error: error
    }))
  )
});

// Export reducer for store config
export const fidPickerReducer = fidPickerFeature.reducer; 